import { Header } from "@/components/layout/header";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />

      <div className="flex-1">
        <main className="py-6">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-semibold text-gray-900 font-serif">Privacy Policy</h1>
              <p className="mt-2 text-gray-500">Effective Date: 4/24/2025</p>
            </div>

            <div className="prose prose-slate max-w-none mx-auto">
              <p className="lead">
                PreVisly is a service provided by EdenTech LLC ("we," "our," or "us"). This policy explains what data we collect and how we use it.
              </p>

              <h2>1. Information We Collect</h2>
              <ul>
                <li><strong>Account Information:</strong> Email, password, and subscription details.</li>
                <li><strong>User Content:</strong> Uploaded screenplays, generated media (images, audio, video), and metadata.</li>
                <li><strong>Usage Data:</strong> IP address, browser type, device identifiers, feature usage, and timestamps.</li>
                <li><strong>Payment Information:</strong> Handled securely by third-party processors like Stripe.</li>
                <li><strong>Moderation Data:</strong> Content flags or scores from third-party moderation systems.</li>
              </ul>

              <h2>2. How We Use Your Data</h2>
              <ul>
                <li>To deliver and improve PreVisly features and services</li>
                <li>To manage transactions and subscriptions</li>
                <li>To render AI-generated content</li>
                <li>To detect and prevent abuse or violations</li>
                <li>To comply with legal obligations</li>
              </ul>

              <h2>3. Public File Access Disclosure</h2>
              <p>
                Files you generate through PreVisly (images, audio, video) are stored using unguessable, random URLs and are publicly accessible via direct link. This enables editing and playback. If you share these URLs or your device/session is compromised, your files may be accessed by others.
              </p>

              <h2>4. Content Moderation</h2>
              <p>
                We use automated third-party services to evaluate user-submitted input before generating content. Flagged content may be delayed or rejected. You will be notified of any moderation issues.
              </p>

              <h2>5. Sharing Your Data</h2>
              <p>
                We do not sell your data. We may share it with trusted service providers (e.g., hosting, email, moderation, and analytics) under strict confidentiality agreements.
              </p>

              <h2>6. Cookies and Tracking</h2>
              <p>
                We use cookies and similar technologies for login sessions, platform performance, and usage insights. You can disable cookies in your browser settings.
              </p>

              <h2>7. Data Retention</h2>
              <p>
                We retain generated content for up to one year for non-subscribers. Active paid subscribers retain content indefinitely. Account data may be retained post-termination for compliance or operational reasons.
              </p>

              <h2>8. Your Rights</h2>
              <p>
                You may request to access, correct, or delete your personal data by contacting <a href="mailto:jon@edentech.com">jon@edentech.com</a>.
              </p>

              <h2>9. Data Security</h2>
              <p>
                We implement industry-standard security, including HTTPS, encryption, secure servers, and abuse prevention measures. No system is perfectly secure, but we actively monitor and improve protections.
              </p>

              <h2>10. Children’s Privacy</h2>
              <p>
                PreVisly is not intended for users under 13. We do not knowingly collect data from minors.
              </p>

              <h2>11. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy periodically. Significant updates will be communicated via email or platform notification. Continued use of the platform indicates acceptance of changes.
              </p>

              <p>© 2025 EdenTech LLC. All rights reserved.</p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
